// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xgTH","type":"styles_type__1Anv0","choices":"styles_choices__3Uh7j"};